export default __webpack_public_path__ + "static/media/gallery-9.63e60f7e.jpg";